<div class="auth-layout">
  <div class="auth-layout__bg">
    <picture>
      <source srcset="assets/images_old/auth/bg.webp 1x, assets/images_old/auth/bg@2x.webp 2x" type="image/webp" />
      <source srcset="assets/images_old/auth/bg.jpg 1x, assets/images_old/auth/bg@2x.jpg 2x" type="image/jpg" />
      <img
        src="assets/images_old/auth/bg.jpg"
        srcset="assets/images_old/auth/bg.jpg 1x, assets/images_old/auth/bg@2x.jpg 2x"
        alt=""
        aria-hidden="true"
      />
    </picture>
  </div>
  <div class="auth-layout__content">
    <div class="col">
      <div class="auth" [ngClass]="{registrationPage: authService.isRegistrationPage}">
        <div toastContainer class="toastr-container" id="auth-layout-toast-container"></div>
        <div class="auth__i">
          <div class="logo">
            <img
              ngSrc="assets/icons/uw-level-access-logo.svg"
              alt="company logo"
              aria-hidden="true"
              height="28"
              width="150"
            />
          </div>

          <router-outlet></router-outlet>
        </div>

        <button
          (click)="openWidget()"
          (mouseenter)="preloadWidget()"
          class="btn-widget-trigger"
          type="button"
          aria-label="Open Accessibility Widget"
        >
          <div class="btn-widget-trigger__i">
            <img src="./assets/images_old/auth/widget-icon.svg" alt="UserWay Accessibility Widget" />
          </div>
        </button>
      </div>
    </div>
    <div class="col">
      <div class="composition">
        <div class="composition__i">
          <ng-lottie [options]="options" (animationCreated)="animationCreated($event)" containerClass="composition__i">
          </ng-lottie>
        </div>
      </div>
      <app-footer></app-footer>
    </div>
  </div>
</div>
